import { components, useApi } from "@appretio/api";
import { useMutation } from "@tanstack/react-query";

type FeedbackCreate = components["schemas"]["FeedbackCreate"];

/**
 * POST a feedback report. Success/error toasts ride the global mutation
 * cache via `meta` (see app/src/createAppQueryClient.ts); the modal keeps
 * its content on failure so nothing the user wrote is lost.
 */
export function useSubmitFeedback() {
  const apiClient = useApi();
  return useMutation({
    mutationFn: async (body: FeedbackCreate) => {
      const response = await apiClient.POST("/v2/feedback/submit-feedback", {
        body
      });
      return response.data?.result;
    },
    meta: {
      successMessage: "Thanks — feedback sent",
      errorMessage: "Failed to send feedback"
    }
  });
}
